/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: any; output: any }
  /** ISO 8601 - UTC format */
  DateTime: { input: any; output: any }
}

export type Admin = {
  __typename?: 'Admin'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type AffectedCustomer = {
  __typename?: 'AffectedCustomer'
  lists: Array<Scalars['String']['output']>
  name: Scalars['String']['output']
  plan: Scalars['String']['output']
}

export type Book = {
  __typename?: 'Book'
  author?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type Card = {
  __typename?: 'Card'
  assignedTo?: Maybe<User>
  createdAt?: Maybe<Scalars['String']['output']>
  data?: Maybe<CardData>
  id: Scalars['Int']['output']
  status: CardStatus
  type: Scalars['String']['output']
  workId: Scalars['String']['output']
}

export type CardData = NewLawsCardData

export type CardInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>
  data: NewLawsCardInput
  id: Scalars['Int']['input']
  status?: InputMaybe<CardStatus>
}

export enum CardStatus {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
}

export type Customer = {
  __typename?: 'Customer'
  accountId: Scalars['ID']['output']
  expiresAt: Scalars['String']['output']
  listStat?: Maybe<ListStat>
  name: Scalars['String']['output']
  numberOfLists: Scalars['Int']['output']
  plan: Plan
  smartName?: Maybe<Scalars['String']['output']>
  status: CustomerStatus
}

export enum CustomerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
}

export type EditorStats = {
  __typename?: 'EditorStats'
  unsettledCount?: Maybe<Scalars['Int']['output']>
}

export enum Importance {
  Fontos = 'FONTOS',
  FontosLehet = 'FONTOS_LEHET',
  NemFontos = 'NEM_FONTOS',
}

export type Jogsz = {
  __typename?: 'Jogsz'
  lcode: Scalars['String']['output']
  text?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type Journal = {
  __typename?: 'Journal'
  gazetteUrl?: Maybe<Scalars['String']['output']>
  issueDate: Scalars['Date']['output']
  issueNumber: Scalars['Int']['output']
  issueYear: Scalars['String']['output']
}

export type JournalStats = {
  __typename?: 'JournalStats'
  journal: Journal
  statuses: Array<RadarStats>
}

export type ListStat = {
  __typename?: 'ListStat'
  numberOfUniqueItems?: Maybe<Scalars['Int']['output']>
  unifiedItemNums?: Maybe<Scalars['Float']['output']>
}

export type Mutation = {
  __typename?: 'Mutation'
  saveRadar: Scalars['String']['output']
  updateCard: Scalars['String']['output']
}

export type MutationSaveRadarArgs = {
  input?: InputMaybe<SaveRadarInput>
}

export type MutationUpdateCardArgs = {
  card?: InputMaybe<CardInput>
}

export type NewLawHandlerStatus = {
  id: Scalars['Int']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export enum NewLawStatus {
  Erdekes = 'ERDEKES',
  Kezelve = 'KEZELVE',
  NemErdekes = 'NEM_ERDEKES',
}

export type NewLawsCardData = {
  __typename?: 'NewLawsCardData'
  issueDate: Scalars['String']['output']
  issueNumber: Scalars['Int']['output']
  issueYear: Scalars['String']['output']
  lawJournalId: Scalars['Int']['output']
  newLaws: Array<PublishedLaw>
}

export type NewLawsCardInput = {
  lawJournalId: Scalars['Int']['input']
  statuses: Array<NewLawHandlerStatus>
}

export enum NewLawsRelevance {
  NemRelevans = 'NEM_RELEVANS',
  Relevans = 'RELEVANS',
  RelevansLehet = 'RELEVANS_LEHET',
}

export enum Plan {
  Normal = 'NORMAL',
  Plus = 'PLUS',
  Promo = 'PROMO',
}

export type PublishedLaw = {
  __typename?: 'PublishedLaw'
  evszam: Scalars['String']['output']
  kibKod: Scalars['String']['output']
  kibocsato: Scalars['String']['output']
  lcode: Scalars['String']['output']
  publishedLawId: Scalars['Int']['output']
  relevance?: Maybe<NewLawsRelevance>
  sorszam: Scalars['String']['output']
  status?: Maybe<NewLawStatus>
  text: Scalars['String']['output']
  tipus: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Query = {
  __typename?: 'Query'
  books?: Maybe<Array<Maybe<Book>>>
  cards: Array<Card>
  customers: Array<Customer>
  hello?: Maybe<Scalars['String']['output']>
  radars: RadarPayload
}

export type QueryRadarsArgs = {
  params?: InputMaybe<RadarParams>
}

export type Radar = {
  __typename?: 'Radar'
  affectedCustomers: Array<AffectedCustomer>
  amendingAct?: Maybe<Jogsz>
  baseAct: Jogsz
  delegatedTo?: Maybe<Admin>
  digest?: Maybe<Scalars['String']['output']>
  enterIntoForce?: Maybe<Array<Scalars['Date']['output']>>
  id: Scalars['Int']['output']
  importance?: Maybe<Importance>
  journal: Journal
  njtUrl?: Maybe<Scalars['String']['output']>
  status: RadarStatus
  tags?: Maybe<Array<Scalars['String']['output']>>
}

export type RadarParams = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type RadarPayload = {
  __typename?: 'RadarPayload'
  editorStats: EditorStats
  items: Array<Radar>
  journalStats: Array<JournalStats>
  totalCount: Scalars['Int']['output']
}

export type RadarStats = {
  __typename?: 'RadarStats'
  count: Scalars['Int']['output']
  status: RadarStatus
}

export enum RadarStatus {
  Approved = 'APPROVED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Problems = 'PROBLEMS',
  Sent = 'SENT',
}

export type SaveRadarInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>
  digest?: InputMaybe<Scalars['String']['input']>
  enterIntoForce?: InputMaybe<Array<Scalars['Date']['input']>>
  id: Scalars['Int']['input']
  importance?: InputMaybe<Importance>
  status?: InputMaybe<RadarStatus>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type User = {
  __typename?: 'User'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CardsQueryVariables = Exact<{ [key: string]: never }>

export type CardsQuery = {
  __typename?: 'Query'
  cards: Array<{
    __typename?: 'Card'
    id: number
    type: string
    workId: string
    status: CardStatus
    createdAt?: string | null
    data?: {
      __typename?: 'NewLawsCardData'
      lawJournalId: number
      issueYear: string
      issueNumber: number
      issueDate: string
      newLaws: Array<{
        __typename?: 'PublishedLaw'
        publishedLawId: number
        text: string
        evszam: string
        sorszam: string
        kibKod: string
        kibocsato: string
        tipus: string
        title: string
        lcode: string
        url: string
        status?: NewLawStatus | null
        relevance?: NewLawsRelevance | null
      }>
    } | null
    assignedTo?: { __typename?: 'User'; id: string; name: string } | null
  }>
}

export type UpdateCardMutationVariables = Exact<{
  card: CardInput
}>

export type UpdateCardMutation = { __typename?: 'Mutation'; updateCard: string }

export type ListRadarsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ListRadarsQuery = {
  __typename?: 'Query'
  radars: {
    __typename?: 'RadarPayload'
    totalCount: number
    editorStats: { __typename?: 'EditorStats'; unsettledCount?: number | null }
    journalStats: Array<{
      __typename?: 'JournalStats'
      journal: {
        __typename?: 'Journal'
        issueYear: string
        issueNumber: number
        issueDate: any
        gazetteUrl?: string | null
      }
      statuses: Array<{ __typename?: 'RadarStats'; status: RadarStatus; count: number }>
    }>
    items: Array<{
      __typename?: 'Radar'
      id: number
      njtUrl?: string | null
      digest?: string | null
      status: RadarStatus
      importance?: Importance | null
      tags?: Array<string> | null
      enterIntoForce?: Array<any> | null
      baseAct: { __typename?: 'Jogsz'; lcode: string; text?: string | null; title?: string | null }
      journal: {
        __typename?: 'Journal'
        issueYear: string
        issueNumber: number
        issueDate: any
        gazetteUrl?: string | null
      }
      affectedCustomers: Array<{
        __typename?: 'AffectedCustomer'
        name: string
        plan: string
        lists: Array<string>
      }>
      delegatedTo?: { __typename?: 'Admin'; id: number; name: string } | null
    }>
  }
}

export type SaveRadarMutationVariables = Exact<{
  input: SaveRadarInput
}>

export type SaveRadarMutation = { __typename?: 'Mutation'; saveRadar: string }

export const CardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Cards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'NewLawsCardData' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'lawJournalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueYear' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newLaws' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'publishedLawId' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'evszam' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sorszam' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'kibKod' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'kibocsato' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tipus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lcode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'relevance' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignedTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardsQuery, CardsQueryVariables>
export const UpdateCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'card' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CardInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'card' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'card' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCardMutation, UpdateCardMutationVariables>
export const ListRadarsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListRadars' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'radars' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'params' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editorStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'unsettledCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'journalStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'journal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'issueYear' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gazetteUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseAct' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'lcode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'journal' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'issueYear' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gazetteUrl' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'njtUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digest' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'importance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enterIntoForce' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affectedCustomers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lists' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'delegatedTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListRadarsQuery, ListRadarsQueryVariables>
export const SaveRadarDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveRadar' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SaveRadarInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveRadar' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveRadarMutation, SaveRadarMutationVariables>
